import React from 'react';
import ProjectDetailView from 'components/ProjectDetailView/ProjectDetailView';
import competitionData from './data';

const Competition = () => {
  return <ProjectDetailView data={competitionData} />;
};

export default Competition;
